// extracted by mini-css-extract-plugin
var _1 = "_rolesRoleDetailsModal-module__action-button";
var _2 = "_rolesRoleDetailsModal-module__form-action-button-disabled";
export { _1 as "action-button", _2 as "form-action-button-disabled" }
